export default {
  background: '#E3E4FA',
	color: '#872657'
};
